/**
 * Welcome offer sticky bubble  (dev request 6)
 *
 * Additive to the existing Klaviyo homepage pop-up, which is untouched.
 *
 * When a Klaviyo Form ID is configured the bubble is only a trigger - it opens
 * that form via the onsite queue, so consent capture, the incentive and any SMS
 * field live in Klaviyo and stay identical across both entry points. Without an
 * ID it expands a panel holding pasted embed HTML instead.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'hth:sticky-signup-dismissed-until';

  function dismissedUntil() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? Number(raw) : 0;
    } catch (error) {
      // Private mode, blocked site data, thumbnail capture - treat as not dismissed.
      return 0;
    }
  }

  function rememberDismissal(days) {
    try {
      var until = Date.now() + days * 24 * 60 * 60 * 1000;
      window.localStorage.setItem(STORAGE_KEY, String(until));
    } catch (error) {
      /* nothing we can do; the bubble simply returns next visit */
    }
  }

  function openKlaviyoForm(formId) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  function init(root) {
    var formId = root.getAttribute('data-klaviyo-form-id');
    var delay = Number(root.getAttribute('data-delay')) || 0;
    var rememberDays = Number(root.getAttribute('data-remember-days')) || 30;
    var panel = root.querySelector('[data-sticky-signup-panel]');

    if (Date.now() < dismissedUntil()) return;

    window.setTimeout(function () {
      root.hidden = false;
      // Next frame, so the transition has a from-state to animate out of.
      window.requestAnimationFrame(function () {
        root.classList.add('is-visible');
      });
    }, delay * 1000);

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-sticky-signup-trigger]');
      var dismiss = event.target.closest('[data-sticky-signup-dismiss]');

      if (dismiss) {
        event.preventDefault();
        root.classList.remove('is-visible');
        rememberDismissal(rememberDays);
        window.setTimeout(function () {
          root.hidden = true;
        }, 250);
        return;
      }

      if (!trigger) return;
      event.preventDefault();

      if (formId) {
        openKlaviyoForm(formId);
        return;
      }

      if (panel) {
        var isOpen = !panel.hidden;
        panel.hidden = isOpen;
        root.classList.toggle('is-open', !isOpen);
      }
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-sticky-signup]');
    for (var i = 0; i < roots.length; i += 1) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
